/** @module csi/view/ToolbarAttributesDropDown */
define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetsInTemplateMixin",
	"dijit/_WidgetBase",
	"csi/html",
	"dojo/text!./ToolbarAttributesDropDown.html",

	"csi/widget/SelectListDnd",
], function(declare,_TemplatedMixin,_WidgetsInTemplateMixin,_WidgetBase,html,template) {

	return declare([_WidgetBase,_TemplatedMixin,_WidgetsInTemplateMixin], {
		baseClass: "csi-view-toolbar-attributes",
		templateString: template,

		// attach points
		actionsNode: null,
		selectListNode: null,

		/** @property {boolean} allowResetColumnWidths - show action to reset column widths */
		allowResetColumnWidths: false,

		/** @property {SelectListDnD} selectListNode */
		selectListNode: null,

		/**
		 * Extension point for when reset action is clicked
		 */
		onReset: function() { },

		/**
		 * Event handler for reset action
		 */
		_onClickReset: function() {
			this.onReset();
		},

		/**
		 * Prevent onExecute events 
		 * Prevent ENTER key in text field from closing the popup (see popup.js)
		 * Code in popup.js checks if this method exists and if yes, it will trigger on "execute" event, if not, it uses "change" event instead
		 * If this method would not present here, default widget.onExecute handler will trigger on "change" event
		 * Default _HasDropDown handler calling closeDropDown(true) - this is what we trying to prevent here 
		 */
		onExecute: function() {},
		
		/**
		 * Display reset action if allowed
		 * @param {boolean} value 
		 */
		_setAllowResetColumnWidthsAttr: function(value) {
			this._set("allowResetColumnWidths", value);
			html.setVisible(this.actionsNode, value);
		}
	});
});